import { render, staticRenderFns } from "./Comp21t3.vue?vue&type=template&id=37e9a01c&scoped=true&"
import script from "./Comp21t3.vue?vue&type=script&lang=js&"
export * from "./Comp21t3.vue?vue&type=script&lang=js&"
import style0 from "./Comp21t3.vue?vue&type=style&index=0&id=37e9a01c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e9a01c",
  null
  
)

export default component.exports